import { render, staticRenderFns } from "./answerDetail.vue?vue&type=template&id=d4804b14&scoped=true&"
import script from "./answerDetail.vue?vue&type=script&lang=ts&"
export * from "./answerDetail.vue?vue&type=script&lang=ts&"
import style0 from "./answerDetail.vue?vue&type=style&index=0&id=d4804b14&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4804b14",
  null
  
)

export default component.exports